import _find from 'lodash/find'
import { shouldForceUpdate, ResetBasketCheckbox } from '~/lib/util/basket'
import { callAWSFrontendExtrasAPI } from '~/lib/util/aws'
import { resolveSitewidePreview } from '~/lib/util/sitewidePreview'

export const state = () => ({})

export const getters = {}

export const mutations = {
  ADD_BREADCRUMBS(state, { path, magazine, page, breadcrumbs }) {
    // console.log('ADD_BREADCRUMBS')
    // console.log('path=', path)
    // console.log('magazine=', magazine)
    // console.log('page=', page)
    // console.log('breadcrumbs=', breadcrumbs)

    let newBreadcrumbs = [
      {
        first: true,
        value: 'magazine subscriptions',
        url: '/',
        last: false
      }
    ]
    if (page) {
      newBreadcrumbs = [
        {
          first: true,
          value: 'magazine subscriptions',
          url: '/',
          last: false
        },
        {
          first: false,
          value: page.value,
          url: page.type,
          last: true
        }
      ]
    } else if (magazine) {
      // trim the extra / from end to start and the magazines placeholder
      let newPath = path.replace(/\/$/, '')

      if (newPath.includes('/magazines-')) {
        // USE CASE 1: breadcrumbs path like /magazines-with-free-gifts/country-living-magazine
        let t = 0
        newPath = newPath.replace(/magazines/g, match => (++t === 2 ? ' ' : match))
      } else {
        // USE CASE 2: other breadcrumbs path
        newPath = newPath.replace(/^\/magazines/, '')
      }
      newPath = newPath.replace(/^\//, '')
      const breadcrumbs = newPath.split('/').filter(item => {
        return item !== undefined
      })
      newBreadcrumbs = [{ first: true, last: false, url: '/', value: 'magazine subscriptions' }]

      // console.log('newBreadcrumbs=', newBreadcrumbs)
      if (breadcrumbs.length >= 2) {
        for (let index = 0; index < breadcrumbs.length; index++) {
          if (index === breadcrumbs.length - 1) {
            // const key = 'id'
            newBreadcrumbs[index + 1] = {
              value: (magazine.h1Title || magazine.title).replace(/-/g, ' '),
              url: magazine.url,
              last: true
            }
          } else if (index === 0) {
            // const key = 'category'
            const url = `/${breadcrumbs[index]}`
            let value = breadcrumbs[index].replace(/magazine-subscriptions-/g, '')
            value = value.replace(/magazine-subscription-/g, '')
            value = value.replace(/-magazine-subscriptions/g, '')
            value = value.replace(/-magazines/g, '')
            value = value.replace(/-/g, ' ')
            value = value.replace(/ and /g, ' & ')
            newBreadcrumbs[index + 1] = {
              value,
              url,
              last: false
            }
          } else if (index === 1) {
            // const key = 'subCategory'
            const url = `/${breadcrumbs[0]}/${breadcrumbs[index]}`
            let value = breadcrumbs[index].replace(/magazine-subscriptions-/g, ' ')
            value = value.replace(/magazine-subscription-/g, '')
            value = value.replace(/-magazine-subscriptions/g, '')
            value = value.replace(/-magazines/g, '')
            value = value.replace(/-/g, ' ')
            value = value.replace(/ and /g, ' & ')
            newBreadcrumbs[index + 1] = {
              value,
              url,
              last: false
            }
          }
        }
      } else if (magazine.breadcrumbCatName === '' || magazine.breadcrumbCatName === null) {
        newBreadcrumbs = [
          {
            first: true,
            value: 'magazine subscriptions',
            url: '/',
            last: false
          },
          {
            first: false,
            value: (magazine.h1Title || magazine.title).replace(/-/g, ' '),
            url: magazine.url,
            last: true
          }
        ]
      } else {
        newBreadcrumbs = [
          {
            first: true,
            value: 'magazine subscriptions',
            url: '/',
            last: false
          },
          {
            first: false,
            value: magazine.breadcrumbCatName,
            url: magazine.breadcrumbCatUrl,
            last: false
          },
          {
            first: false,
            value: (magazine.h1Title || magazine.title).replace(/-/g, ' '),
            url: magazine.url,
            last: true
          }
        ]
      }
    } else if (breadcrumbs) {
      newBreadcrumbs = [...breadcrumbs]
    }
    console.log('newBreadcrumbs FINAL', newBreadcrumbs)
    state.UI.breadcrumbs = newBreadcrumbs
  },

  addToCart(state, item) {
    console.log('addToCart productId=' + item.offer.productId)
    // Inc +1 to the selected item
    if (item.offer.productId) {
      const a = _find(state.basket.items, function(i) {
        return i.offer.productId === item.offer.productId
      })
      if (a === undefined) {
        console.log('addToCart PUSH')
        const itemToAdd = item
        itemToAdd.offer.qty = 1
        state.basket.items.push(itemToAdd)
      } else {
        console.log('addToCart ADD QTY')
        a.offer.qty++
      }
    }
  }
}
export const actions = {
  SAVE_ISMOBILE({ commit }, value) {
    console.log(`SAVE_ISMOBILE value=${value}`)
    commit('UI/isMobile', value)
  },

  AGGREGATE_BASKET_TOTALS({ commit, state }) {
    try {
      console.log(`AGGREGATE_BASKET_TOTALS state.basket.id=${state.basket.id}`)

      // Update the Basket's Totals
      if (state.basket.id) {
        commit('basket/aggregateTotals', state.basket)
      }

      return {}
    } catch (error) {
      return { error: { message: error.message, code: error.code } }
    }
  },

  async LOAD_ACTIVE_BASKET_MONGODB({ dispatch, commit }, params) {
    try {
      const id = params.id
      const updatedAt = params?.updatedAt
      const basket = params?.basket
      let useCache = false

      if (!id) {
        console.warn(`LOAD_ACTIVE_BASKET_MONGODB no id provided`)
        return false
      }

      if (basket?.id && shouldForceUpdate(updatedAt)) {
        useCache = false
        console.info(`LOAD_ACTIVE_BASKET_MONGODB ACTION REFRESH useCache=${useCache}`)
      } else {
        useCache = true
        console.info(`LOAD_ACTIVE_BASKET_MONGODB UP TO DATE useCache=${useCache}`)
      }

      console.log(`LOAD_ACTIVE_BASKET_MONGODB id=${id} useCache=${useCache}`)

      // Calling the Frontend Api for the Basket (we have axios-cache LRU in place)
      process.env.NODE_ENV !== 'production' && require('axios-debug-log')

      // BASKET API
      console.info(`GET '${this.$config.APIProxyURL}/basket/id/${id}'`)
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${this.$config.APIProxyURL}/basket/id/${id}`,
        headers: {
          'Cache-Control': useCache ? 'max-age=3600' : 'max-age=0',
          'Content-Type': 'application/json'
        }
      }

      await this.$axios
        .request(config)
        .then(response => {
          if (response?.data?.payload?.enabled === false) {
            console.log(`LOAD_ACTIVE_BASKET_MONGODB AXIOS Basket=${id} not ACTIVE`)
            commit('basket/id', undefined)
            commit('cart/CartId', undefined) // DROP the CartId
            commit('cart/updatedAt', undefined)
            commit('basket/payload', undefined)
          }
          if (response?.data?.payload) {
            commit('basket/payload', response.data.payload)
            commit('cart/CartId', id)
            commit('cart/updatedAt', new Date())
            commit('basket/id', id)
            params.context.$nuxt.$emit('BASKET_READY', { ready: true, basket: response.data.payload })
          }
          return response
        })
        .catch(error => {
          console.log('LOAD_ACTIVE_BASKET_MONGODB AXIOS error=', error)
          commit('basket/id', undefined)
          commit('cart/CartId', undefined) // DROP the CartId
          commit('cart/updatedAt', undefined)
          commit('basket/payload', undefined)
          return undefined
        })

      // Get the lates version of the Upsell List
      await dispatch('GET_UPSELL_MONGODB', { skip: false })

      return true
    } catch (error) {
      console.log('LOAD_ACTIVE_BASKET_MONGODB error=', error)
      commit('basket/id', undefined)
      commit('cart/CartId', undefined)
      commit('cart/updatedAt', undefined)
      commit('basket/payload', undefined)
      return false
    }
  },

  async GET_UPSELL_MONGODB({ commit, state }, params) {
    // UPSELL API
    console.log(`GET_UPSELL_MONGODB skip=${params?.skip}`)
    if (state?.basket?.upsell?.length > 0) {
      console.log(`GET_UPSELL_MONGODB - upsell already in state, skipping API call`)
      return
    }

    if (params?.skip === true) {
      console.log(`GET_UPSELL_MONGODB - upsell already up to date`)
      return
    }

    const useCache = state?.UI?.useCache || true
    console.log(`GET_UPSELL_MONGODB state.UI.useCache=`, state?.UI?.useCache)
    console.info(`GET '/api/v1/utility/get-basket-upsell-offers'`)
    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${this.$config.APIProxyURL}/utility/get-basket-upsell-offers`,
      headers: {
        'Cache-Control': useCache ? 'max-age=3600' : 'max-age=0',
        'Content-Type': 'application/json'
      }
    }
    await this.$axios
      .request(config)
      .then(response => {
        console.info('UPSELL response=', response.data)
        commit('basket/upsell', response.data.payload)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async UPDATE_BASKET_MONGODB({ dispatch, commit }, params) {
    try {
      const data = JSON.stringify(params.request)
      console.info(`UPDATE_BASKET_MONGODB type=${params.type} params=`, params)
      console.info(`UPDATE_BASKET_MONGODB type=${params.type} request=`, params.request)
      console.info(`UPDATE_BASKET_MONGODB type=${params.type} data=`, data)

      let url = `${this.$config.APIProxyURL}/basket/id/${params.id}`
      if (!params?.id) {
        url = `${this.$config.APIProxyURL}/basket`
      }
      console.info(`UPDATE_BASKET_MONGODB url=${url}`)
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url,
        headers: {
          'Cache-Control': 'max-age=0',
          'Content-Type': 'application/json'
        },
        data
      }

      console.info(`POST '${url}'`)

      // Calling the Frontend Api for the Basket (we have axios-cache LRU in place)
      process.env.NODE_ENV !== 'production' && require('axios-debug-log')
      let response = await this.$axios.request(config)

      if (response?.data?.payload) {
        // Get the latest version of the basket if present with no cache
        // This will avoid some inconsistency with the Promotion TYPE=AUTOMATIC
        // WORKAROUND we are calling the extra GET /basket/id/{id}  only on a basket of 2 or more items
        if (params.id && response.data?.payload?.items?.length >= 2) {
          response = await dispatch('LOAD_BASKET_BY_ID_MONGODB', { id: params.id })
          if (response === undefined) {
            const error = new Error(`Unexpected Error`)
            error.code = 'UNEXPECTED_ERROR'
            throw error
          }
          response?.data?.totals && commit('basket/totals', response.data.totals)
        }

        // Get the lates version of the Upsell List
        await dispatch('GET_UPSELL_MONGODB', { skip: false })

        commit('basket/payload', response.data.payload)
        commit('cart/CartId', response.data.payload.id)
        commit('cart/updatedAt', new Date())
        commit('cart/FunnelSteps', {
          billing: false,
          delivery: false,
          payment: false,
          success: false
        })
        commit('basket/id', response.data.payload.id)

        await ResetBasketCheckbox({ payload: response.data.payload, context: this })

        // Remove Vue3 localStorage
        if (!process.server && window?.localStorage) {
          console.log('UPDATE_BASKET_MONGODB - Remove Vue3 localStorage')
          window && window.localStorage.removeItem('Order')
          window && window.localStorage.removeItem('order')
          window && window.localStorage.removeItem('user')
        }

        return response?.data?.payload
      }
    } catch (error) {
      console.log('UPDATE_BASKET_MONGODB error=', error)
      return { error: { message: error.message, code: error.code } }
    }
  },

  async LOAD_BASKET_BY_ID_MONGODB(context, { id }) {
    try {
      const useCache = false
      console.log(`LOAD_BASKET_BY_ID_MONGODB id=${id} useCache=${useCache}`)

      // Calling the Frontend Api for the Basket (we have axios-cache LRU in place)
      process.env.NODE_ENV !== 'production' && require('axios-debug-log')

      // BASKET API
      console.info(`GET '${this.$config.APIProxyURL}/basket/id/${id}'`)
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${this.$config.APIProxyURL}/basket/id/${id}`,
        headers: {
          'Cache-Control': useCache ? 'max-age=3600' : 'max-age=0',
          'Content-Type': 'application/json'
        }
      }

      const respone = await this.$axios
        .request(config)
        .then(response => {
          if (response?.data?.payload) {
            console.log('LOAD_BASKET_BY_ID_MONGODB payload=', response.data.payload)
            return response
          }
          return undefined
        })
        .catch(error => {
          console.log('LOAD_BASKET_BY_ID_MONGODB AXIOS GET error=', error)
          return undefined
        })

      return respone
    } catch (error) {
      console.log('LOAD_BASKET_BY_ID_MONGODB error=', error)
      return undefined
    }
  },

  // WA https://github.com/nuxt/nuxt.js/issues/3259
  async nuxtServerInit({ commit }, { route, $config, query, $axios }) {
    // Fill the debug flag
    commit('UI/debug', $config.debug || route?.query?.JMAGDebug === 'true')

    // Fill the useCache flag
    let useCache = $config.AWSAPIGatewayUseCache
    if (route?.query?.useCache) {
      useCache = route?.query?.useCache === 'true'
    }
    commit('UI/useCache', useCache)

    // Fill the Status Code
    commit('UI/statusCode', 200)

    console.info(`nuxtServerInit route=${route?.fullPath} query=`, query)
    // console.log('nuxtServerInit query=', query)
    // console.log('nuxtServerInit QS useCache=', useCache)

    if (route?.fullPath === '/health' || route?.fullPath === '/frontend-health') {
      console.info('nuxtServerInit HEALTH CHECK - skipping store init')
      return
    }

    console.info('nuxtServerInit - calling AWSFrontendExtrasAPI with useCache=', useCache)
    const { sitelinks, sitelinksmobile, sitewide, sitewidemobile, bestsellers, timestamp, promoheaderbanners } = await callAWSFrontendExtrasAPI({
      context: { route, $config, query, $axios },
      useCache
    })
    // console.log(`nuxtServerInit AWSFrontendExtrasAPI sitelinks=`, sitelinks)
    // console.log(`nuxtServerInit AWSFrontendExtrasAPI sitelinksmobile=`, sitelinksmobile)
    // console.log(`nuxtServerInit AWSFrontendExtrasAPI bestsellers=`, bestsellers)
    // console.log(`nuxtServerInit AWSFrontendExtrasAPI timestamp=`, timestamp)
    // console.log(`nuxtServerInit AWSFrontendExtrasAPI promoheaderbanners=`, promoheaderbanners)
    // console.log(`nuxtServerInit AWSFrontendExtrasAPI sitewide=`, sitewide)
    // console.log(`nuxtServerInit AWSFrontendExtrasAPI sitewidemobile=`, sitewidemobile)

    if (query !== undefined) {
      if (query[$config.OptionsAddQueryStringToURLKey] !== undefined) {
        const queryParams = {}
        queryParams[$config.OptionsAddQueryStringToURLKey] = query[$config.OptionsAddQueryStringToURLKey]
        // console.log(`nuxtServerInit UPDATE pageQueryParams=`, queryParams)
        commit('UI/pageQueryParams', queryParams)
      } else {
        commit('UI/pageQueryParams', {})
      }
    }

    sitelinks && commit('utility/sitelinks', sitelinks, { root: true })
    sitelinksmobile && commit('utility/sitelinksmobile', sitelinksmobile, { root: true })

    // Sitewide preview: when an admin opens ?action=preview&preview-sitewide[&preview-sitewidemobile]=<b64>
    // override the matching sitewide slot with the decoded object. Each slot is independent —
    // a missing/invalid param leaves the live sitewide for that slot. In-memory only, never persisted.
    const sitewidePreview = resolveSitewidePreview(query)
    const previewDesktop = sitewidePreview && sitewidePreview.sitewide
    const previewMobile = sitewidePreview && sitewidePreview.sitewidemobile
    if (sitewidePreview) {
      console.log('[nuxtServerInit] sitewide preview ACTIVE — overriding published sitewide', {
        desktop: previewDesktop?.image_url,
        mobile: previewMobile?.image_url
      })
    }
    commit('UI/isSitewidePreview', !!sitewidePreview, { root: true })
    commit('UI/sitewidePreviewDesktop', previewDesktop || undefined, { root: true })
    commit('UI/sitewidePreviewMobile', previewMobile || undefined, { root: true })

    const finalSitewide = previewDesktop || sitewide
    const finalSitewidemobile = previewMobile || sitewidemobile
    finalSitewide && commit('utility/sitewide', finalSitewide, { root: true })
    finalSitewidemobile && commit('utility/sitewidemobile', finalSitewidemobile, { root: true })
    bestsellers && commit('utility/bestsellers', bestsellers, { root: true })
    timestamp && commit('utility/timestamp', timestamp, { root: true })
    promoheaderbanners && commit('utility/DEAFULT_RAW_promoheaderbanners', promoheaderbanners, { root: true })
  }
}
